<nav class="sidebar">
  <ul>
    <li *ngFor="let item of sidebarItems">
      <div class="page-link"
           [ngClass]="{'danger-link': item.danger}"
           [routerLink]="item.link"
           routerLinkActive="active-link"
           (click)="item.action?.()">
        <i [class]="item.icon"></i>
        <span>{{ 'sidebarItems.' + item.title | translate }}</span>
      </div>
    </li>
  </ul>
</nav>